import {
  ClipboardDocumentCheckIcon,
  ChartBarIcon,
  LightBulbIcon,
  UserGroupIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

const steps = [
  {
    number: 1,
    title: 'Complete a quick wellness and home snapshot',
    icon: ClipboardDocumentCheckIcon,
  },
  {
    number: 2,
    title: 'Receive a personalized ThriveScore and insights',
    icon: ChartBarIcon,
  },
  {
    number: 3,
    title: 'Take action with clear, prioritized guidance',
    icon: LightBulbIcon,
  },
  {
    number: 4,
    title: 'Stay aligned through the ThriveCircle',
    icon: UserGroupIcon,
  },
  {
    number: 5,
    title: 'Build confidence over time, steadily and proactively',
    icon: SparklesIcon,
  },
];

const HowItComesTogetherSection = () => {
  return (
    <div className="py-20 lg:py-28 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Simple to Start.{' '}
            <span className="text-primary">Powerful Over Time.</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative">
            {/* Vertical connector line */}
            <div className="absolute left-7 top-8 bottom-8 w-px bg-gradient-to-b from-primary/30 via-primary/20 to-primary/10 hidden sm:block"></div>

            <div className="space-y-4">
              {steps.map((step, index) => (
                <div
                  key={step.number}
                  className="group relative flex items-center gap-6 p-5 pl-0 sm:pl-5 rounded-md hover:bg-muted/30 transition-all duration-300"
                >
                  {/* Step number circle */}
                  <div className="relative z-10 w-14 h-14 rounded-md text-primary font-bold flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300 shadow-raised">
                    <step.icon className="w-6 h-6" />
                  </div>

                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <span className="text-xs font-bold uppercase tracking-wider text-primary/60">
                        Step {step.number}
                      </span>
                    </div>
                    <p className="text-foreground font-bold text-lg">{step.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center mt-14">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full">
            <span className="text-primary font-bold">
              This is proactive living at home.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItComesTogetherSection;
